import store from 'state/configure-store';
import multiCurrencySelectorRenderer from './multi-currency-selector-renderer';
import multiCurrencyRenderer from './multi-currency-renderer';
import actions from '../../state/actions/multi-currency';

let _booted = false;

const activateMultiCurrency = currency => {
    multiCurrencySelectorRenderer.render(store);
    multiCurrencyRenderer.render(store);
    store.dispatch(actions.setCurrencyIfNotChosen(currency));
};

const boot = initData => {
    const multiCurrencyEnabled = !!initData.featureSwitches['multi-currency'];
    if (!multiCurrencyEnabled) {
        return;
    }
    if (_booted) {
        return;
    }

    _booted = true;
    if (window && window.location.search.indexOf('force-currency-dev') > -1) {
        activateMultiCurrency('EUR');
        return;
    }
    if (initData.memberCountry === 'Sverige') {
        return;
    }
    const url = 'https://geo.tradera.com/api/country';
    fetch(url, {
        method: 'GET',
        dataType: 'json'
    })
        .then(response => {
            return response.json();
        })
        .then(data => {
            if (!data || data.isoCode === 'SE') {
                return;
            }
            activateMultiCurrency(data.currency);
        });
};

export default {
    boot
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/multi-currency/multi-currency-boot.js